import type { OfferBuyerTier } from "../../lib/marketplace-offers-api";

/** "t2" -> 2. Falls back to 0 on an unrecognized shape (never throws — a
 *  malformed tier string should degrade the headline, not crash the row). */
export function tierOrdinal(tier: OfferBuyerTier | string): number {
  const match = /^t(\d+)$/.exec(tier);
  return match ? Number.parseInt(match[1], 10) : 0;
}
